import script from "./CampaignsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignsSection.vue?vue&type=script&setup=true&lang=js"

import "./CampaignsSection.vue?vue&type=style&index=0&id=fa9b3678&scoped=true&lang=css"

import exportComponent from "/home/caknaummah-console/webapps/caknaummah-console/releases/1793606032358/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa9b3678"]])

export default __exports__